import NavigationArrowDown from './assets/navigation-arrow-down.svg';
import NavigationArrowLeft from './assets/navigation-arrow-left.svg';
import NavigationArrowRight from './assets/navigation-arrow-right.svg';
import DropdownArrowRight from './assets/dropdown-arrow-right.svg';
import NavigationArrowUp from './assets/navigation-arrow-up.svg';
import ArrowLeft from './assets/arrow-left.svg';
import ArrowRight from './assets/arrow-right.svg';
import ArrowUp from './assets/arrow-up.svg';
import ArrowDown from './assets/arrow-down.svg';
import Burger from './assets/burger.svg';
import Decline from './assets/decline.svg';
import Globe from './assets/globe.svg';
import Avatar from './assets/avatar.svg';
import Search from './assets/search.svg';
import ExternalLink from './assets/external-link.svg';
import ShoppingCart from './assets/shopping-cart.svg';
import ShoppingCartFull from './assets/shopping-cart-full.svg';
import NotificationBell from './assets/notification-bell.svg';
import Comment from './assets/comment.svg';
import ContactUsChat from './assets/contact-us-chat.svg';
import ContactUsMail from './assets/contact-us-mail.svg';
import ContactUsPhone from './assets/contact-us-phone.svg';
import ArrowDropdown from './assets/arrow-dropdown.svg';
import Ellipsis from './assets/ellipsis.svg';
import Home from './assets/home.svg';
import Facebook from './assets/facebook.svg';
import Twitter from './assets/twitter.svg';
import Bluesky from './assets/bluesky.svg';
import X from './assets/x.svg';
import Youtube from './assets/youtube.svg';
import LinkedIn from './assets/linkedin.svg';
import Instagram from './assets/instagram.svg';
import Slideshare from './assets/slideshare.svg';
import Email from './assets/email.svg';
import Xing from './assets/xing.svg';
import GooglePlus from './assets/google-plus.svg';
import WhatsApp from './assets/whatsapp.svg';
import Edit from './assets/edit.svg';
import SlimArrowDown from './assets/slim-arrow-down.svg';
import Warning from './assets/warning.svg';
import Error from './assets/error.svg';
import StatusPositive from './assets/status-positive.svg';

export const Icons = {
  NavigationArrowDown,
  NavigationArrowLeft,
  NavigationArrowRight,
  NavigationArrowUp,
  DropdownArrowRight,
  ArrowUp,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  Burger,
  Decline,
  Globe,
  Avatar,
  Search,
  ExternalLink,
  ShoppingCart,
  ShoppingCartFull,
  NotificationBell,
  Comment,
  ContactUsChat,
  ContactUsMail,
  ContactUsPhone,
  ArrowDropdown,
  Ellipsis,
  Home,
  Facebook,
  Twitter,
  Bluesky,
  X,
  Youtube,
  LinkedIn,
  Instagram,
  Slideshare,
  Email,
  Xing,
  GooglePlus,
  WhatsApp,
  Edit,
  SlimArrowDown,
  Information: StatusPositive,
  Warning,
  Error,
  StatusPositive
};
